<template>
  
  <div class="monitor-word-container">
	  
    <!-- 工具栏 -->
    <div class="tool-box">
      <el-button type="primary" @click="handleAdd">单个添加</el-button>
      <el-button type="success" @click="openBatchDialog">批量添加</el-button>
      <el-button type="danger" @click="handleBatchDelete" :disabled="selectedIds.length === 0">
        批量删除
	  
      </el-button>
	  <el-button v-if="admin==2" @click="toAdmin">系统词</el-button>
    </div>

    <!-- 列表 -->
    <el-table
      :data="list"
      v-loading="loading"
      border
      ref="table"
      @selection-change="handleSelectionChange"
      style="width:100%;margin-top:10px;"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="word" label="监听词语"></el-table-column>
      <el-table-column
        prop="matchType"
        label="匹配类型"
        width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.matchType === 1 ? "包含匹配" : "全字匹配" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        width="90"
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? "启用" : "禁用" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createUserName" label="创建人" width="100"></el-table-column>
      <el-table-column prop="updateUserName" label="修改人" width="100"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
      <el-table-column prop="updateTime" label="修改时间" width="180"></el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" danger @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
	    <el-pagination
	      @current-change="getLists"
	      :current-page="pageNum"
	      :page-size="pageSize"
	      layout="total, prev, pager, next, jumper"
	      :total="total"
	      style="margin-top:20px;text-align:right"
	    >
	    </el-pagination>

    <!-- 单个新增/修改弹窗 -->
    <el-dialog :title="formTitle" :visible.sync="dialogForm" width="500px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="监听词语">
          <el-input v-model="form.word" placeholder="请输入词语"></el-input>
        </el-form-item>
        <el-form-item label="匹配类型">
          <el-radio v-model="form.matchType" :label="1">包含匹配</el-radio>
          <el-radio v-model="form.matchType" :label="2">全字匹配</el-radio>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio v-model="form.status" :label="1">启用</el-radio>
          <el-radio v-model="form.status" :label="0">禁用</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogForm = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 批量添加弹窗 -->
    <el-dialog title="批量添加敏感词" :visible.sync="batchDialog" width="60%">
      <el-input
        v-model="batchInput"
        type="textarea"
        :rows="6"
        placeholder="多个词语用 ; 分号分隔"
      ></el-input>
      <div style="margin-top:10px;color:#666;">
        已拆分：{{ wordList.length }} 个词语
      </div>
      <div slot="footer">
        <el-button @click="batchDialog = false">取消</el-button>
        <el-button type="primary" @click="submitBatch">确定批量添加</el-button>
      </div>
    </el-dialog>
	<el-dialog title="系统敏感词" :visible.sync="isadmin" width="60%">
	  
	  <div style="margin-top:10px;color:#666;height: 60%;overflow-y: auto;">
	    {{adminlist}}
	  </div>
	  <div slot="footer">
	    <el-button @click="isadmin = false">关闭</el-button>
	
	  </div>
	</el-dialog>
  </div>
</template>

<script>
import jsQR from 'jsqr';

// import this.API from "@/utils/this.API"; // 你的axios封装
export default {
  name: "MonitorWord",
  data() {
    return {
      loading: false,
      list: [],
      selectedIds: [],

      // 表单
      dialogForm: false,
      formTitle: "新增",
      form: {
        id: null,
        word: "",
        matchType: 1,
        status: 1,
      },

      // 批量
      batchDialog: false,
      batchInput: "",
      wordList: [],
	  login:null,
	  pageSize:10,
	  pageNum:1,
	  total:0,
	  adminlist:[],
	  admin:localStorage.getItem('userType')||'',
	  isadmin:false,
    };
  },
  created() {
    this.getList();
	if(localStorage.getItem("userType")!=1){
		this.adminMonitorWork()
	}
  },
  methods: {
	  toAdmin(){
		  if(this.adminlist.length>2){
			  this.isadmin=true
		  }
		  
	  },
	  async adminMonitorWork(){
		  //标准中台
		  try{
			  const res = await this.API.get(this.API.fileurl.getAllWords,{
				  orgId:0,
				  platformFlag:1
			  });
			  this.adminlist=JSON.stringify(res.data)
			  console.log('eeee',res.data)
		  }catch(error){
			  
		  }
	  },
	  loginOpen(text) {
	  	this.login = this.$loading({
	  		lock: true,
	  		text: text,
	  		zIndex: 100001,
	  		spinner: 'el-icon-loading',
	  		background: 'rgba(0, 0, 0, 0.7)'
	  	});
	  },
	  noLogin() {
	  	if (this.login) {
	  		this.login.close()
	  	}
	  },
    getLists(val){
		this.pageNum=val
		this.getList()
	},
    async getList() {
      this.loading = true;
      try {
        const res = await this.API.get(this.API.fileurl.getMonitorWorkList,{
			pageNum:this.pageNum,
			pageSize:this.pageSize
		});
        
		this.list = res.data.records;
		this.total=res.data.total
      } finally {
        this.loading = false;
      }
    },

    // ==================
    // 打开新增
    // ==================
    handleAdd() {
      this.formTitle = "新增敏感词";
      this.form = { word: "", matchType: 1, status: 1, id: null };
      this.dialogForm = true;
    },

    // ==================
    // 打开编辑
    // ==================
    handleEdit(row) {
      this.formTitle = "修改敏感词";
      this.form = { ...row };
      this.dialogForm = true;
    },

    // ==================
    // 提交新增/修改
    // ==================
    async submitForm() {
      try {
        if (this.form.id) {
          let res=await this.API.put(this.API.fileurl.putMonitorUpdate, this.form);
		  if(res.data.code==200){
			  if(res.data.msg!='当前机构该平台已存在相同词汇，无法修改'){
				  this.getList()
			  }
			  this.$message.success(res.data.msg);
		  }else{
			  this.$message.success(res.data.msg);
		  }
        } else {
          let res=await this.API.post(this.API.fileurl.postMonitorWorkAdd, this.form);
		  if(res.data.code===200){
			  if(res.data.msg!='该监听词已存在'){
				  this.getList()
			  }
			  this.$message.success(res.data.msg);
			  
		  }else{
			  this.$message.error(res.data.msg);
		  }
        }
        this.dialogForm = false;
        this.getList();
      } catch (err) {
        this.$message.warning(err.msg || "操作失败");
      }
    },

    // ==================
    // 单个删除
    // ==================
    async handleDelete(id) {
      this.$confirm("确定删除？", "提示").then(async () => {
        await this.API.deleted(this.API.fileurl.deletedMonitorWorkDelete + id);
        this.$message.success("删除成功");
        this.getList();
      });
    },

    // ==================
    // 批量选择
    // ==================
    handleSelectionChange(val) {
      this.selectedIds = val.map((item) => item.id);
    },

    // ==================
    // 批量删除
    // ==================
    async handleBatchDelete() {
      this.$confirm("确定删除选中项？").then(async () => {
        await this.API.deleted(this.API.fileurl.deletedMonitorWorkBatchDelete, {
          data: this.selectedIds,
        });
        this.$message.success("批量删除成功");
        this.getList();
      });
    },

    // ==================
    // 打开批量添加
    // ==================
    openBatchDialog() {
      this.batchDialog = true;
      this.batchInput = "";
    },

    // ==================
    // 提交批量添加（;分割）
    // ==================
    async submitBatch() {
      if (!this.batchInput.trim()) {
        return this.$message.warning("请输入内容");
      }
	  this.loginOpen(`批量新增中`)
      // 按 ; 拆分 + 去空 + 去重
      const arr = this.batchInput
        .split(";")
        .map((x) => x.trim())
        .filter((x) => x);
      this.wordList = [...new Set(arr)];

      try {
        const res = await this.API.post(this.API.fileurl.postMonitorWorkBatchAdd, this.wordList);
        this.$alert(
          `成功：${res.data.successCount} 条\n失败：${res.data.failCount} 条`,
          "批量结果"
        );
		this.noLogin()
        this.batchDialog = false;
        this.getList();
      } catch (err) {
		  this.noLogin()
        this.$message.warning(err.msg || "批量添加失败");
      }
    },
  },
};
</script>

<style scoped>
.tool-box {
  display: flex;
  gap: 10px;
}
</style>